import axios from "axios";

export async function eth_usd (){
        return (await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd"))
}

export async function bnb_usd (){
        return (await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd"))
}

export async function xtz_usd (){
        return (await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=tezos&vs_currencies=usd"))
}

export async function sol_usd (){
        return (await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd"))
}

export async function tron_usd (){
        return (await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=tron&vs_currencies=usd"))
}

export async function ada_usd (){
        return (await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=cardano&vs_currencies=usd"))
}

export async function avax_usd (){
        return (await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=avalanche-2&vs_currencies=usd"))
}